{
    "LicenceManagementPage_Title": "Gestion des licences",
    "LicenceManagementPage_Subtitle": "Gérer les affectations de périphériques et d'utilisateurs pour un périmètre téléphonique sélectionné.",
    "LicenceManagementPage_Tile_Analytics": "Analyse de l'expérience client",
    "LicenceManagementPage_Tile_Score": "Score CX",
    "LicenceManagementPage_Tile_Record": "Enregistrement CX",
    "LicenceManagementPage_Tile_Integration": "Intégration de l'expérience client",
    "LicenceManagementPage_Tile_Licences": "Licences",
    "LicenceManagementPage_Column_DeviceNumber": "Appareil",
    "LicenceManagementPage_Column_Username": "Nom d'utilisateur",
    "LicenceManagementPage_Column_Email": "E-mail",
    "LicenceManagementPage_Column_HasDevice": "Appareil",
    "LicenceManagementPage_Column_Agent": "Agent",
    "LicenceManagementPage_Column_WelcomeEmail": "Courriel de bienvenue",
    "LicenceManagementPage_Column_Licences": "Licences",
    "LicenceManagementPage_Column_Actions": "Actes",
    "LicenceManagementPage_Type_Device": "Appareil",
    "LicenceManagementPage_Type_User": "Utilisateur",
    "LicenceManagementPage_Popup_TelSys": "Serveur de téléphonie",
    "LicenceManagementPage_Popup_Partition": "Partition",
    "LicenceManagementPage_Popup_Device": "Appareil",
    "LicenceManagementPage_Popup_Username": "Nom d'utilisateur",
    "LicenceManagementPage_Popup_Email": "E-mail",
    "LicenceManagementPage_Popup_Close": "Fermer",
    "LicenceManagementPage_LicencePopup_Title": "Gérer les licences de produits",
    "LicenceManagementPage_LicencePopup_Licence": "Licence",
    "LicenceManagementPage_LicencePopup_ScoreUserCalls": "Évaluation des appels des utilisateurs",
    "LicenceManagementPage_LicencePopup_RecordUserCalls": "Enregistrement des appels des utilisateurs",
    "LicenceManagementPage_LicencePopup_IntegrationEnabled": "Activé",
    "LicenceManagementPage_LicencePopup_On": "Sur",
    "LicenceManagementPage_LicencePopup_Off": "Désactivé",
    "LicenceManagementPage_LicencePopup_Enabled": "Activé",
    "LicenceManagementPage_LicencePopup_Disabled": "Désactivé",
    "LicenceManagementPage_LicencePopup_EmailRequired": "Veuillez ajouter une adresse e-mail avant d'enregistrer les modifications de licence pour cet appareil.",
    "LicenceManagementPage_Email_AddTooltip": "Cliquez pour ajouter une adresse e-mail et créer un utilisateur",
    "LicenceManagementPage_EssentialsExtension": "Essentiels (Extension)",
    "LicenceManagementPage_Empty": "Rien trouvé ici",
    "LicenceManagementPage_WelcomeEmail_Title": "Renvoyer l'e-mail de bienvenue à \"{}\"",
    "LicenceManagementPage_WelcomeEmail_Confirm": "Souhaitez-vous renvoyer l'e-mail de bienvenue à \"{}\" ?",
    "LicenceManagementPage_WelcomeEmail_Success": "L'e-mail a été envoyé avec succès à \"{}\"",
    "LicenceManagementPage_WelcomeEmail_Fail": "Une erreur inattendue s'est produite lors de l'envoi du courriel. Veuillez réessayer.",
    "LicenceManagementPage_Licence_SaveFailed": "Les paramètres actuels de l'utilisateur n'ont pas pu être lus, les licences n'ont donc pas été enregistrées. Veuillez réessayer.",
    "LicenceManagementPage_Column_LicencesCount": "[{} Licences]",
    "LicenceManagementPage_Tick_Save": "Enregistrer les modifications de la ligne",
    "LicenceManagementPage_Tick_InvalidEmail": "Veuillez saisir une adresse e-mail valide pour créer l'utilisateur.",
    "LicenceManagementPage_Licence_ScoringEnabled": "Système de notation activé",
    "LicenceManagementPage_Licence_RecordingEnabled": "Enregistrement activé",
    "LicenceManagementPage_Licence_WithScoring": "{} + Notation",
    "LicenceManagementPage_Licence_WithRecording": "{} + Enregistrement",
    "LicenceManagementPage_Username_NoUserTooltip": "Ce nom d'utilisateur sera utilisé lors de la création d'un nouvel utilisateur.",
    "NAME": "Langue de la page de gestion des licences"
}